import { is } from './is';
import { IPlainObject } from '../models';

export function removeEmptyValues<T = IPlainObject>(value: T): T {
  return Object.keys(value).reduce(
    (acum, key): T => {
      if (is.empty(value[key])) {
        return acum;
      }

      return {
        ...acum,
        [key]: value[key],
      };
    },
    <T>{},
  );
}
